import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import RealtimeState from '../../RealtimeState';
const CORE_POSTED_EVENT = 'Flarum\\Post\\Event\\Posted';
const CORE_RENAMED_EVENT = 'discussionRenamed';
const CORE_REVISED_EVENT = 'revisedEvent';
const POST_RESTORED_EVENT = 'postRestored';
export default function () {
  extend(DiscussionPage.prototype, 'oninit', function () {
    this.websocketEventPosted = data => {
      // Capture BEFORE the payload (and the refetch below) updates postIds:
      // once new posts are in the store, viewingEnd()'s 1-post drift
      // tolerance can no longer tell "was at the end, several posts arrived
      // at once" apart from "viewing an interior window" — so a single
      // missed event would permanently disable live-append (#4717).
      const wasViewingEnd = !!this.stream?.viewingEnd();
      const discussion = app.store.pushPayload(data);
      if (discussion.id() === this.discussion?.id() && this.stream) {
        const oldCount = this.discussion.commentCount();
        app.store.find('discussions', this.discussion.id()).then(() => {
          if (wasViewingEnd) {
            this.stream.syncEnd().then(() => m.redraw());
          } else {
            m.redraw();
          }
          if (!document.hasFocus()) {
            app.setTitleCount(Math.max(0, this.discussion.commentCount() - oldCount));
            $(window).one('focus', () => {
              app.setTitleCount(0);
            });
          }
        });
      }
    };
    this.websocketEventStreamUpdate = data => {
      // Same pre-payload capture as websocketEventPosted (#4717) — event
      // posts (sticky/lock/rename) move postIds too.
      const wasViewingEnd = !!this.stream?.viewingEnd();
      const discussion = app.store.pushPayload(data);
      if (discussion.id() === this.discussion?.id() && this.stream) {
        app.store.find('discussions', this.discussion.id()).then(() => {
          if (wasViewingEnd) {
            this.stream.syncEnd().then(() => m.redraw());
          } else {
            m.redraw();
          }
        });
      }
    };
  });
  extend(DiscussionPage.prototype, 'oncreate', function () {
    // Bind handlers against the current channel objects. Extracted so it can
    // re-fire on reconnect — see flarum/framework#4597. On reconnect the
    // previous channel objects are discarded with the previous Pusher
    // instance, so re-binding against the new channels is non-duplicating.
    const bindHandlers = () => {
      app.websocket_channels.public?.bind(CORE_POSTED_EVENT, this.websocketEventPosted);
      app.websocket_channels.user?.bind(CORE_POSTED_EVENT, this.websocketEventPosted);
      app.websocket_channels.public?.bind(CORE_RENAMED_EVENT, this.websocketEventStreamUpdate);
      app.websocket_channels.user?.bind(CORE_RENAMED_EVENT, this.websocketEventStreamUpdate);
      app.websocket_channels.public?.bind(CORE_REVISED_EVENT, this.websocketEventPosted);
      app.websocket_channels.user?.bind(CORE_REVISED_EVENT, this.websocketEventPosted);

      // A restored post rejoins the stream the way a new one arrives.
      app.websocket_channels.public?.bind(POST_RESTORED_EVENT, this.websocketEventPosted);
      app.websocket_channels.user?.bind(POST_RESTORED_EVENT, this.websocketEventPosted);
      for (const eventName of RealtimeState.getDiscussionStreamEventNames()) {
        app.websocket_channels.public?.bind(eventName, this.websocketEventStreamUpdate);
        app.websocket_channels.user?.bind(eventName, this.websocketEventStreamUpdate);
      }
    };
    bindHandlers();
    this._realtimeReconnectDisposer = RealtimeState.onChannelsReconnected(bindHandlers);
  });

  // Unbind only this page's handlers: an unbind by event name alone would
  // also remove every other component's handler for the same event.
  extend(DiscussionPage.prototype, 'onremove', function () {
    this._realtimeReconnectDisposer?.();
    this._realtimeReconnectDisposer = null;
    app.websocket_channels.public?.unbind(CORE_POSTED_EVENT, this.websocketEventPosted);
    app.websocket_channels.user?.unbind(CORE_POSTED_EVENT, this.websocketEventPosted);
    app.websocket_channels.public?.unbind(CORE_RENAMED_EVENT, this.websocketEventStreamUpdate);
    app.websocket_channels.user?.unbind(CORE_RENAMED_EVENT, this.websocketEventStreamUpdate);
    app.websocket_channels.public?.unbind(CORE_REVISED_EVENT, this.websocketEventPosted);
    app.websocket_channels.user?.unbind(CORE_REVISED_EVENT, this.websocketEventPosted);
    app.websocket_channels.public?.unbind(POST_RESTORED_EVENT, this.websocketEventPosted);
    app.websocket_channels.user?.unbind(POST_RESTORED_EVENT, this.websocketEventPosted);
    for (const eventName of RealtimeState.getDiscussionStreamEventNames()) {
      app.websocket_channels.public?.unbind(eventName, this.websocketEventStreamUpdate);
      app.websocket_channels.user?.unbind(eventName, this.websocketEventStreamUpdate);
    }
  });
}